module.exports = __webpack_public_path__ + "static/media/heattread-3.416714f7.jpg";